/* Flipbook — czytnik katalogu oparty o StPageFlip (assets/page-flip.browser.js).
   Używany wyłącznie przez templates/page.flipbook.liquid. */
(function () {
  'use strict';

  function init() {
    var root = document.getElementById('flipbook-root');
    var dataEl = document.getElementById('flipbook-pages');
    if (!root || !dataEl || typeof St === 'undefined') return;

    var pages;
    try { pages = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var total = pages.length;
    if (total < 2) return;

    var PAGE_W = parseInt(root.dataset.pageWidth, 10) || 1000;
    var PAGE_H = parseInt(root.dataset.pageHeight, 10) || 1414;
    var RATIO = PAGE_W / PAGE_H;
    var PAGE_LABEL = root.dataset.labelPage || 'Page';

    var stage = document.getElementById('fb-stage');
    var inner = document.getElementById('fb-stage-inner');
    var countEl = document.getElementById('fb-count');
    var slider = document.getElementById('fb-slider');
    var btnPrev = document.getElementById('fb-prev');
    var btnNext = document.getElementById('fb-next');
    var btnZoom = document.getElementById('fb-zoom-btn');
    var btnFull = document.getElementById('fb-full');
    var zoomOverlay = document.getElementById('fb-zoom');
    var zoomScroll = document.getElementById('fb-zoom-scroll');
    var zoomImg = document.getElementById('fb-zoom-img');
    var btnZoomClose = document.getElementById('fb-zoom-close');

    var pf = null;
    var pageEls = [];
    var loaded = new Array(total);
    var portrait = false;
    var currentIdx = startIndexFromHash();
    var saveData = !!(navigator.connection && navigator.connection.saveData);

    slider.max = total;

    /* ---------- ładowanie obrazków ---------- */

    function ensure(i, cb) {
      if (i < 0 || i >= total) { if (cb) cb(); return; }
      if (loaded[i]) { if (cb) cb(); return; }
      loaded[i] = true;
      var img = pageEls[i] && pageEls[i].querySelector('img');
      if (!img) { if (cb) cb(); return; }
      var done = function () {
        pageEls[i].classList.add('is-loaded');
        if (cb) cb();
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', function () { if (cb) cb(); }, { once: true });
      img.src = img.dataset.src;
    }

    function ensureAround(i, radius) {
      for (var k = i - radius; k <= i + radius; k++) ensure(k);
    }

    function trickle() {
      if (saveData) return;
      var i = 0;
      while (i < total && loaded[i]) i++;
      if (i >= total) return;
      ensure(i, function () { setTimeout(trickle, 120); });
    }

    /* ---------- budowa stron ---------- */

    function createPageEls() {
      pageEls = [];
      for (var i = 0; i < total; i++) {
        var d = document.createElement('div');
        d.className = 'fb-page';
        d.dataset.index = i;
        if (i === 0 || i === total - 1) d.dataset.density = 'hard';
        var img = document.createElement('img');
        img.alt = PAGE_LABEL + ' ' + (i + 1);
        img.draggable = false;
        img.decoding = 'async';
        img.dataset.src = pages[i].src;
        if (loaded[i]) {
          img.src = pages[i].src;
          d.classList.add('is-loaded');
        }
        d.appendChild(img);

        // klikalne obszary przeniesione z adnotacji PDF-a (współrzędne w %)
        var links = pages[i].links || [];
        for (var k = 0; k < links.length; k++) {
          var ln = links[k];
          var a = document.createElement('a');
          a.className = 'fb-link';
          a.href = ln.u;
          a.target = '_blank';
          a.rel = 'noopener';
          var l = Math.max(0, ln.l - 0.4);
          var t = Math.max(0, ln.t - 0.6);
          a.style.left = l + '%';
          a.style.top = t + '%';
          a.style.width = Math.min(100 - l, ln.w + 0.8) + '%';
          a.style.height = Math.min(100 - t, ln.h + 1.2) + '%';
          d.appendChild(a);
        }

        pageEls.push(d);
      }
    }

    /* StPageFlip KLONUJE elementy stron do wyświetlania (klony nie mają
       listenerów), więc obsługa linków i dblclick idzie delegacją na scenie
       w fazie capture — działa dla oryginałów i klonów, a zdarzenia z linku
       nie docierają do silnika kartkowania (klik nawiguje normalnie). */
    ['mousedown', 'touchstart', 'click'].forEach(function (type) {
      stage.addEventListener(type, function (e) {
        if (e.target && e.target.closest && e.target.closest('.fb-link')) {
          e.stopPropagation();
        }
      }, { capture: true, passive: true });
    });

    stage.addEventListener('dblclick', function (e) {
      var pageEl = e.target && e.target.closest ? e.target.closest('.fb-page') : null;
      if (pageEl && pageEl.dataset.index) openZoom(parseInt(pageEl.dataset.index, 10));
    });

    /* ---------- dopasowanie do ekranu ---------- */

    function decideMode() {
      var w = inner.clientWidth;
      var h = inner.clientHeight;
      return w < 640 || w < h * 0.9; // true = portret (jedna strona)
    }

    function fit(fitEl) {
      // StPageFlip sam ustawia szerokość 100% i proporcje przez padding-bottom,
      // więc wymiarujemy tylko kontener nadrzędny (szerokość => wysokość wynika z proporcji).
      var w = inner.clientWidth;
      var h = inner.clientHeight;
      var unit = portrait ? RATIO : 2 * RATIO; // szerokość na jednostkę wysokości
      var bw = Math.floor(Math.min(w, h * unit));
      fitEl.style.width = bw + 'px';
      return bw;
    }

    /* ---------- inicjalizacja / przebudowa ---------- */

    function build() {
      if (pf) {
        try { currentIdx = pf.getCurrentPageIndex(); } catch (e) {}
        try { pf.destroy(); } catch (e) {}
        pf = null;
      }
      inner.innerHTML = '';
      var fitEl = document.createElement('div');
      fitEl.id = 'fb-fit';
      var holder = document.createElement('div');
      holder.id = 'fb-book';
      fitEl.appendChild(holder);
      inner.appendChild(fitEl);

      portrait = decideMode();
      var blockW = fit(fitEl);
      createPageEls();
      for (var i = 0; i < pageEls.length; i++) holder.appendChild(pageEls[i]);

      // stretch wybiera portret tylko gdy blockW < 2*minWidth, więc minWidth
      // dobieramy tak, by orientacja zawsze zgadzała się z decideMode()
      pf = new St.PageFlip(holder, {
        width: PAGE_W,
        height: PAGE_H,
        size: 'stretch',
        minWidth: portrait ? Math.ceil(blockW / 2) + 1 : 160,
        maxWidth: 3200,
        minHeight: 220,
        maxHeight: 4400,
        usePortrait: portrait,
        showCover: true,
        flippingTime: portrait ? 550 : 650,
        maxShadowOpacity: 0.25,
        mobileScrollSupport: false,
        clickEventForward: true,
        showPageCorners: true
      });
      pf.loadFromHTML(pageEls);
      if (currentIdx > 0 && currentIdx < total) pf.turnToPage(currentIdx);
      pf.on('flip', function (e) {
        currentIdx = e.data;
        ensureAround(currentIdx, 4);
        syncUi();
      });
      ensureAround(currentIdx, 5);
      syncUi();
    }

    /* ---------- UI ---------- */

    function displayRange(idx) {
      if (portrait || idx === 0 || idx >= total - 1) return String(Math.min(idx + 1, total));
      var left = idx % 2 === 1 ? idx : idx - 1;
      var right = Math.min(left + 1, total - 1);
      return (left + 1) + '–' + (right + 1);
    }

    function syncUi() {
      countEl.textContent = displayRange(currentIdx) + ' / ' + total;
      slider.value = currentIdx + 1;
      btnPrev.disabled = currentIdx <= 0;
      btnNext.disabled = currentIdx >= total - 1;
      if (history.replaceState) {
        history.replaceState(null, '', '#p=' + (currentIdx + 1));
      }
    }

    function startIndexFromHash() {
      var m = /[#&]p=(\d+)/.exec(location.hash);
      if (!m) return 0;
      var n = parseInt(m[1], 10) - 1;
      return n > 0 && n < total ? n : 0;
    }

    btnPrev.addEventListener('click', function () { if (pf) pf.flipPrev(); });
    btnNext.addEventListener('click', function () { if (pf) pf.flipNext(); });

    slider.addEventListener('input', function () {
      var target = parseInt(slider.value, 10) - 1;
      if (!pf || target === currentIdx) return;
      ensureAround(target, 2);
      pf.turnToPage(target);
      currentIdx = pf.getCurrentPageIndex();
      syncUi();
    });

    document.addEventListener('keydown', function (e) {
      if (zoomOverlay && !zoomOverlay.hidden) {
        if (e.key === 'Escape') closeZoom();
        return;
      }
      if (!pf) return;
      if (e.key === 'ArrowLeft') { pf.flipPrev(); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { pf.flipNext(); e.preventDefault(); }
      else if (e.key === 'Home') { pf.turnToPage(0); currentIdx = 0; syncUi(); }
      else if (e.key === 'End') { pf.turnToPage(total - 1); currentIdx = total - 1; syncUi(); }
    });

    /* ---------- pełny ekran ---------- */

    var fsTarget = document.documentElement;
    var fsSupported = !!(fsTarget.requestFullscreen || fsTarget.webkitRequestFullscreen);
    if (!fsSupported && btnFull) btnFull.hidden = true;

    if (btnFull) {
      btnFull.addEventListener('click', function () {
        var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
        if (fsEl) {
          (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        } else {
          (fsTarget.requestFullscreen || fsTarget.webkitRequestFullscreen).call(fsTarget);
        }
      });
      document.addEventListener('fullscreenchange', function () {
        root.classList.toggle('is-fullscreen', !!document.fullscreenElement);
      });
    }

    /* ---------- zoom ---------- */

    function zoomIndexForButton() {
      if (portrait || currentIdx === 0 || currentIdx >= total - 1) return currentIdx;
      return currentIdx % 2 === 1 ? currentIdx : currentIdx - 1;
    }

    function openZoom(idx) {
      if (!zoomOverlay) return;
      zoomImg.src = pages[idx].hi || pages[idx].src;
      zoomImg.alt = PAGE_LABEL + ' ' + (idx + 1);
      zoomOverlay.hidden = false;
      document.body.classList.add('fb-zoom-open');
      zoomImg.onload = function () {
        zoomScroll.scrollLeft = (zoomScroll.scrollWidth - zoomScroll.clientWidth) / 2;
        zoomScroll.scrollTop = 0;
      };
    }

    function closeZoom() {
      if (!zoomOverlay) return;
      zoomOverlay.hidden = true;
      zoomImg.removeAttribute('src');
      document.body.classList.remove('fb-zoom-open');
    }

    if (btnZoom) btnZoom.addEventListener('click', function () { openZoom(zoomIndexForButton()); });
    if (btnZoomClose) btnZoomClose.addEventListener('click', closeZoom);

    /* ---------- ochrona gestów na dotyku ----------
       Zoom na mobile TYLKO przyciskiem (podwójne/przypadkowe tapnięcia nie
       otwierają niczego), a gesty wielopalcowe (pinch itp.) są ucinane w fazie
       capture, zanim dotrą do silnika kartkowania lub przeglądarki. */

    ['touchstart', 'touchmove'].forEach(function (type) {
      stage.addEventListener(type, function (e) {
        if (e.touches && e.touches.length > 1) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, { passive: false, capture: true });
    });

    // pinch-zoom Safari/iOS zgłasza osobnymi zdarzeniami gesture*
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (type) {
      stage.addEventListener(type, function (e) { e.preventDefault(); }, { passive: false });
    });

    /* ---------- resize ---------- */

    var resizeTimer = null;
    var lastW = window.innerWidth;
    var lastH = window.innerHeight;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var wChanged = Math.abs(window.innerWidth - lastW) > 4;
        var hChanged = Math.abs(window.innerHeight - lastH) > 120;
        var modeChanged = decideMode() !== portrait;
        if (wChanged || hChanged || modeChanged) {
          lastW = window.innerWidth;
          lastH = window.innerHeight;
          build();
        }
      }, 180);
    });

    /* ---------- start ---------- */

    build();
    setTimeout(trickle, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
